import { SubmissionIntervalNotification } from '../../commonTypes/NotificationTypes/timelog.types';
import { TranslationFormatter } from './TranslationFormatter';

export class NotificationTimelogionService {
    private formatter: TranslationFormatter;

    constructor(formatter: TranslationFormatter) {
        this.formatter = formatter;
    }
    public generateSubmissionIntervalMessage(notification: SubmissionIntervalNotification): string {
        const { endDate } = notification.message;
        const endDateObj = new Date(endDate);

        const monthYear = endDateObj.toLocaleString('en-US', { month: 'long', year: 'numeric' });

        return this.formatter.getTranslation('notificationMessages.submissionInterval', {
            initiatorFullName: this.formatter.getFullName(notification.initiators),
            date: monthYear,
        });
    }
}
